(function($) {
    // GDPR cookie banner
    $(document).ready( function(){ 

        var cookieconsent = initCookieConsent();
        cookieconsent.run({
            current_lang : 'cs',
            page_scripts: true,
            autorun : true, 							
            delay : 0,
            autoclear_cookies : true,	
            theme_css : globaldata.theme_url +'/assets/styles/cookiebanner.css',
            gui_options: {
            consent_modal : {
                layout : 'box',               // box/cloud/bar 
                position : 'top center',     // bottom/top + left/right/center
                transition: 'slide'             // zoom/slide
            },
            settings_modal : {
                layout : 'box',                 // box/bar
                transition: 'slide',            // zoom/slide
                }
            },
            
            onAccept: function(cookies){				
            if(cookieconsent.allowedCategory('necessary')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"necessary"
            });
            }
            
            
            if(cookieconsent.allowedCategory('tracking')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"tracking"
            });
            }
            
            if(cookieconsent.allowedCategory('performance')){
                var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"performance"
            });
            }
            
        },
    
            languages : {
                'en' : {
                    consent_modal : {
                        title :  globaldata.title,
                        description :  globaldata.consent_description,
                        primary_btn: {
                            text: globaldata.primarybtn_text,
                            role: 'accept_all'  //'accept_selected' or 'accept_all'
                        },
                        secondary_btn: {
                            text : globaldata.secondarybtn_text,
                            role : 'settings'   //'settings' or 'accept_necessary'
                        }
                    },
                    settings_modal : {
                        title : globaldata.title,
                        save_settings_btn : globaldata.pref_btn_text,
                        accept_all_btn : globaldata.primarybtn_text,
                        close_btn_label: globaldata.cookie_close_btn_text,  
                    cookie_table_headers : [
                        {col1: globaldata.cookie_table_header1 }, 
                        {col2: globaldata.cookie_table_header2 }, 


                    ],
                        blocks : [
                            {
                                title : globaldata.cookiemaintitle,
                                description: globaldata.block_description,
                            },{
                                title : globaldata.func_cookie_title,
                                description: globaldata.func_cookie_desc,
                                toggle : {
                                    value : 'necessary',
                                    enabled : true,
                                    readonly: true
                                },
                                cookie_table: [
                                {
                                    col1: 'cc_cookie',
                                    col2: globaldata.func_cookie_table2,
                                },
                                {
                                    col1: '*.youtube.com',
                                    col2: globaldata.func_cookie_youtube,
                                }
                                ]
                            },{
                                title : globaldata.anal_cookie_title,
                                description: globaldata.anal_cookie_desc,
                                toggle : {
                                    value : 'performance',
                                    enabled : true,
                                    readonly: false
                                },
                                cookie_table: [
                                {
                                    col1: '_ga/_ga*, _gid',
                                    col2: globaldata.anal_cookie_table_desc1,
                                },
                                                            {
                                    col1: '_gcl_au',
                                    col2: globaldata.anal_cookie_table_desc2,
                                }
                            ]
                            }
                           
                            
                        ]
                    }
                }
            }
        });
        
        if(!cookieconsent.validCookie('cc_cookie')){
            var dataLayer = window.dataLayer || [];
                dataLayer.push({
                event:"CookieConsent",
                consentType:"empty"
        });

        }
    });
    
	
})( jQuery );